module.exports = __webpack_public_path__ + "static/img/62.f9c8b49.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/62.png
// module id = 420
// module chunks = 1 2 3 4 5 6 7 8